import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Filter16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M1 4C1 3.58579 1.33579 3.25 1.75 3.25H14.25C14.6642 3.25 15 3.58579 15 4C15 4.41421 14.6642 4.75 14.25 4.75H1.75C1.33579 4.75 1 4.41421 1 4ZM12.25 8.75L3.75 8.75C3.33579 8.75 3 8.41421 3 8C3 7.58579 3.33579 7.25 3.75 7.25L12.25 7.25C12.6642 7.25 13 7.58579 13 8C13 8.41421 12.6642 8.75 12.25 8.75ZM9.25 12.75L6.75 12.75C6.33579 12.75 6 12.4142 6 12C6 11.5858 6.33579 11.25 6.75 11.25L9.25 11.25C9.66421 11.25 10 11.5858 10 12C10 12.4142 9.66421 12.75 9.25 12.75Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
